(function () {
    'use strict';

    angular
        .module('rms.common')
        .factory('ListTemplateViewStateService', ListTemplateViewStateService);

    function ListTemplateViewStateService(lodash, ListTemplateViewCtrlService) {
        const mem = {};
        return {
            init: init,
            sync: sync,
            refreshAll: refreshAll,
            destroy: destroy,
        };

        function init(vm, identifier, options) {
            lodash.set(mem, identifier, new ListTemplateViewCtrlService(options));
            sync(vm, identifier);
        }

        function sync(vm, identifier) {
            if (lodash.has(mem, identifier)) {
                vm.service = mem[identifier];
            }
        }

        function refreshAll() {
            lodash.forIn(mem, function(value) {
               value.refresh();
            });
        }

        function destroy(identifier) {
            delete mem[identifier];
        }
    }
})();